(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/assets/javascripts/utils-marquee.js') >= 0) return;  svs.modules.push('/widgets/ticker/assets/javascripts/utils-marquee.js');
"use strict";


const {
  PromoLetters,
  TickerBrand
} = svs.widget.ticker.constants;

const createMarqueeSeparator = brand => {
  const separatorEl = document.createElement('div');
  const promoLetters = PromoLetters[brand];
  separatorEl.innerHTML = svs.widget.ticker.templates.promo_separator({
    brand,
    promoLetters
  });
  return separatorEl.firstChild;
};

const createMarqueePromoItem = item => {
  const promoItemEl = document.createElement('div');
  promoItemEl.innerHTML = svs.widget.ticker.templates.promo({
    promoText: item
  });
  return promoItemEl.firstChild;
};

const createMarqueeWinnerItem = (item, brand, index) => {
  const winnerItemEl = document.createElement('div');
  const promoLetter = PromoLetters[brand][index];
  winnerItemEl.innerHTML = svs.widget.ticker.templates.winners({
    winner: item,
    brand,
    promoLetter,
    index
  });
  const link = winnerItemEl.querySelector('.ticker-item__game-link');
  if (link) {
    link.addEventListener('click', () => {
      svs.components.analytics.trackEvent({
        action: 'game ticker',
        category: 'Navigation',
        opt_label: "".concat(brand).concat(brand === TickerBrand.BINGO ? ",".concat(item.gameName) : ''),
        opt_value: item.amountSek
      });
    });
  }
  return winnerItemEl.firstChild;
};
const utilsMarquee = {
  createMarqueeSeparator,
  createMarqueePromoItem,
  createMarqueeWinnerItem
};
setGlobal('svs.widget.ticker.utilsMarquee', utilsMarquee);

 })(window);